export default __webpack_public_path__ + "static/media/sms-notification.7745f537.svg";